// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const BankIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Bank/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M6.667 11.667v2.5m3.333-2.5v2.5m3.333-2.5v2.5M2.5 17.5h15m-15-9.167h15m-15-2.5L10 2.5l7.5 3.333m-14.167 2.5h13.334V17.5H3.333V8.333Z"
}));
export default BankIcon;
